import { tundora, catskill } from '../colors';
export var MuiDialogTitle = {
    customOverrides: {
        header: {
            backgroundColor: tundora,
            color: catskill,
        },
    },
};
